import React, { Component } from "react";
import classnames from "classnames";
import { withRouter } from "react-router-dom";

import { withStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Grid from "@material-ui/core/Grid";
import LogoutIcon from "@material-ui/icons/ExitToApp";

import { APPBAR_HEIGHT, FoodBookLogo } from "../../utils/Constants";
import { DASHBOARD_PAGE_URL } from "../../utils/Route";

const styles = theme => ({
  root: {
    flexGrow: 1
  },
  LimitSize: {
    maxWidth: "1200px",
    width: "100%",
    margin: "0 auto",
    height: APPBAR_HEIGHT.desktop
  },
  Header: {
    backgroundColor: "#F37020"
  },
  Center: {
    position: "relative",
    left: "50%",
    top: "50%",
    transform: "translate(-50%, -50%)",
    cursor: "pointer"
  },
  LogoutStyle: {
    width: "2rem",
    height: "2rem",
    position: "absolute",
    transform: "translateY(-50%)",
    top: "50%",
    left: "-2rem",
    color: "white"
  },
  LogoutText: {
    display: "inline-block",
    color: "white"
  }
});

class DashboardDesktopHeader extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pose: "close"
    };
  }

  profileClickHandler = () => {
    // Show and hide the dropdown

    if (this.state.pose === "open") {
      this.setState({ pose: "close" });
    } else {
      this.setState({ pose: "open" });
    }
  };

  closeMenu = () => {
    // Close the dropdown
    this.setState({ pose: "close" });
  };

  render() {
    const { classes } = this.props;
    const {
      root,
      LimitSize,
      Header,
      LogoutStyle,
      LogoutText,
      Center
    } = classes;

    return (
      <div className={root}>
        <AppBar position="fixed" className={Header}>
          <Toolbar variant="dense">
            <div className={LimitSize}>
              <Grid
                container
                style={{ width: "100%", height: "100%" }}
                justify="space-between"
              >
                <Grid item>
                  <img
                    src={FoodBookLogo}
                    alt="logo"
                    className={Center}
                    style={{
                      height: APPBAR_HEIGHT.desktop,
                      cursor: "pointer",
                      padding: "14px"
                    }}
                    onClick={() => this.props.history.push(DASHBOARD_PAGE_URL)}
                  />
                </Grid>
                {/* <Grid item>
                  <div className={Center} onClick={this.props.logoutHandler}>
                    <LogoutIcon className={LogoutStyle} />
                    <p className={LogoutText}>LOGOUT</p>
                  </div>
                </Grid> */}
              </Grid>
            </div>
          </Toolbar>
        </AppBar>
      </div>
    );
  }
}

export default withRouter(withStyles(styles)(DashboardDesktopHeader));



// WEBPACK FOOTER //
// ./src/components/Settings/SettingsDesktopHeader.js